import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Breakpoint, Container } from '@mui/material';
import { useAuth } from '../../../hooks/use-auth.hook';
import Header from '../../header/header';
import Footer from '../../footer/footer';
import './global.layout.scss';
import { env } from '../../../env';

/**
 * Layout entourant toutes les pages de l'application
 * @constructor
 */
export default function GlobalLayout() {
    //Récupération du contexte
    let auth = useAuth();
    let maxWidth: false | Breakpoint = 'lg';
    let isHome: boolean = false;
    // récupération locations
    const location = useLocation();
    if (location.pathname === '/') {
        maxWidth = false;
        isHome = true;
    }
    const logoHeader = '/' + env.REACT_APP_THEME + '/logo-header.jpg';

    // Intégration du header dans les pages
    return (
        <React.Fragment>
            <Header img={logoHeader} isAuth={!!auth.user} user={auth?.user} />
            <Container
                disableGutters
                maxWidth={maxWidth}
                className={isHome ? 'layout-enveloppe-home' : 'layout-enveloppe'}
            >
                <Outlet />
            </Container>
            <Footer />
        </React.Fragment>
    );
}
